import { type Dayjs } from 'dayjs'
import React, { memo, useId } from 'react'

import { daysGenerator } from '@/legacy-src/utilities/helpers'
import { capitalize } from '@/legacy-src/utilities/textUtilities'

import { Checkbox } from '@/src/domains/design-system/components/Checkbox'
import { Label } from '@/src/domains/design-system/components/Label'

type Props = {
  readonly days: number[]
  readonly selectDay: (day: number) => void
}

const generatedDays = daysGenerator()

const DaysCheckBox: React.FC<Props> = ({ days, selectDay }) => {
  const id = useId()

  return (
    <>
      {generatedDays.map((dayjsDay: Dayjs) => {
        const day = dayjsDay.format('dddd')
        const dayAsNumber = dayjsDay.weekday()
        return (
          <div className="flex items-center gap-3" key={day}>
            <Checkbox
              id={`${id}-${dayAsNumber}`}
              checked={days?.includes(dayAsNumber)}
              onCheckedChange={() => selectDay(dayAsNumber)}
            />
            <Label variant="selection-control" className="grow" htmlFor={`${id}-${dayAsNumber}`}>
              {capitalize(day)}
            </Label>
          </div>
        )
      })}
    </>
  )
}
export default memo<Props>(DaysCheckBox)
